import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setIsModalActive } from '../../VNTabs/ActionCreators'
import { getIsAuthFailedOrder, getSelectedOrder } from '../../selectors/order'
import { isTabbed } from '../../utils/orderStates'
import RoundButton from '../../components/RoundButton'
import { getBackbarMode } from '../../selectors/config'
import { getIsKiosk } from '../../selectors/menus'
import { getUsbPrintingEnabled } from '../../selectors/printer'
import AddTipAndFinalizeModals from './AddTipAndFinalizeModals'
import NetworkPrintErrorModal from './NetworkPrintErrorModal'
import useBackBar from '../hooks/useBackBar'
import ConnectionRequiredModal from '../../components/Modals/ConnectionRequiredModal'
import { getNetworkAvailableValue } from '../../utils/networkConnected'

const BackBarButtons = ({ className }) => {
  const dispatch = useDispatch()
  const order = useSelector(getSelectedOrder)
  const isKiosk = useSelector(getIsKiosk)
  const isTab = isTabbed(order)
  const isBackBar = useSelector(getBackbarMode)
  const usbPrintingEnabled = useSelector(getUsbPrintingEnabled)
  const isAuthFailedTab = useSelector(getIsAuthFailedOrder)
  const [showTipAndFinalize, setShowTipAndFinalize] = useState(false)
  const [showNetworkPrintErrorModal, setShowNetworkPrintErrorModal] = useState(false)
  const [showConnectionRequiredModal, setShowConnectionRequiredModal] = useState(false)
  const { printSlipHandler, printCheckHandler } = useBackBar()
  const networkConnected = getNetworkAvailableValue()

  const shouldRender = useMemo(() => {
    if (!isBackBar) return false
    if (isKiosk) return false
    if (!isTab && !isAuthFailedTab) return false

    return true
  }, [isKiosk, isTab, isBackBar, isAuthFailedTab])

  const finalizeHandler = useCallback(() => {
    if (!networkConnected && order?.wasCreatedInStadium) {
      setShowConnectionRequiredModal(true)
      return
    }

    setShowTipAndFinalize(true)
  }, [networkConnected, order?.wasCreatedInStadium])

  const checkIfCanPrintCheck = useCallback(() => {
    if (!usbPrintingEnabled && !order?.wasCreatedInStadium) {
      setShowNetworkPrintErrorModal(true)
      return
    }
    printCheckHandler()
  }, [usbPrintingEnabled, order?.wasCreatedInStadium, printCheckHandler])

  const checkIfCanPrintSlip = useCallback(() => {
    if (!networkConnected && order?.wasCreatedInStadium) {
      setShowConnectionRequiredModal(true)
      return
    }
    printSlipHandler()
  }, [networkConnected, order?.wasCreatedInStadium, printSlipHandler])

  // T37353: Temporary Fix for Chrome 52 Contextual Modals
  useEffect(() => {
    if (showTipAndFinalize || showNetworkPrintErrorModal || showConnectionRequiredModal) {
      dispatch(setIsModalActive(true))
      return
    }
    dispatch(setIsModalActive(false))
  }, [showTipAndFinalize, showNetworkPrintErrorModal, showConnectionRequiredModal, dispatch])

  useEffect(() => {
    return () => {
      dispatch(setIsModalActive(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!shouldRender) {
    return null
  }

  return (
    <>
      {showConnectionRequiredModal && <ConnectionRequiredModal onButtonClick={() => setShowConnectionRequiredModal(false)} />}
      <NetworkPrintErrorModal
        showNetworkPrintErrorModal={showNetworkPrintErrorModal}
        setShowNetworkPrintErrorModal={setShowNetworkPrintErrorModal}
      />
      <AddTipAndFinalizeModals showTipAndFinalize={showTipAndFinalize} setShowTipAndFinalize={setShowTipAndFinalize} />
      <div>
        <RoundButton className={className} text="Print Check" onClick={checkIfCanPrintCheck} />
        <RoundButton text="Print Slip" className={className} onClick={checkIfCanPrintSlip} />
        <RoundButton className={className} text="Add Tip & Finalize" onClick={finalizeHandler} />
      </div>
    </>
  )
}

export default BackBarButtons
